import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Document, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeDocument(request: Boundaries["removeDocument"]["request"]): void;
}

function useRemoveDocument(folder: Identifiable<Document>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveDocumentRequestPending(folder),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveDocumentRequestSuccess(folder),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveDocumentRequestFailure(folder),
    ),
    removeDocument: core.removeDocument,
  };
}

export { useRemoveDocument };
